import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { SecaoService } from "../../services/SecaoService";

export default {
    name: "GerenciarSecoes",
    components: {
        Breadcrumb,
        ActionButtons,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Seções',
                disabled: true
            }
        ],
        // Controle de responsividade
        isMobile: false,
        isTablet: false,
        windowWidth: 0,
        // Headers base da tabela
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px', priority: 1 },
            { text: 'Código Seção', align: 'center', value: 'codigo_secao', width: '150px', priority: 1 },
            { text: 'Descrição Seção', align: 'center', value: 'descricao', width: '400px', priority: 1 },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px', priority: 2 },
        ],
        filters: {
            codigoSecaoFilter: '',
            descricaoSecaoFilter: '',
            statusFilter: null,
        },
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        items: [],
        itemSelected: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        showFilters: true,
        loading: false
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        // Headers computados - sempre mostra todas as colunas
        computedHeaders() {
            // Sempre retorna todas as colunas, independente da resolução
            // O scroll horizontal cuidará da navegação em telas pequenas
            return this.baseHeaders;
        }
    },
    created() {
        this.listarSecoesPaginado();
        this.handleResize();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        'filters.codigoSecaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarSecoesPaginado();
            }
        },
        'filters.descricaoSecaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarSecoesPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarSecoesPaginado();
            }
        }
    },
    methods: {
        async listarSecoesPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await SecaoService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter seções.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar seções:', error);
            } finally {
                this.loading = false;
            }
        },
        async destroySecoes() {
            try {
                const ids = this.itemSelected.map(secao => secao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("secoes[]", id);
                });

                const response = await SecaoService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir seções.');
                }

                this.listarSecoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir seções:', error);
            }
        },
        async activateSecoes() {
            try {
                const ids = this.itemSelected.map(secao => secao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("secoes[]", id);
                });

                const response = await SecaoService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar seções.');
                }

                this.listarSecoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar seções:', error);
            }
        },
        async deactivateSecoes() {
            try {
                const ids = this.itemSelected.map(secao => secao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("secoes[]", id);
                });

                const response = await SecaoService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar seções.');
                }

                this.listarSecoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar seções:', error);
            }
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            if (this.filters.codigoSecaoFilter) {
                filter.append("codigo", this.filters.codigoSecaoFilter);
            }

            if (this.filters.descricaoSecaoFilter) {
                filter.append("descricao", this.filters.descricaoSecaoFilter);
            }

            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }

            return filter;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getRowClass(item) {
            return item.ativo ? 'row-active' : 'row-inactive';
        },
        navigateToCreate() {
            this.$router.push('/secoes/criar');
        },
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/secoes/editar/${this.itemSelected[0].id}`);
            }
        },
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handlePageChanged(page) {
            this.page = page;
            this.listarSecoesPaginado();
        },
        handleItemsPerPageChanged(itemsPerPage) {
            this.itemsPerPage = itemsPerPage;
            this.page = 1;
            this.listarSecoesPaginado();
        },

        // Método para detectar mudanças no tamanho da tela
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }
    }
};
